import axios from 'axios'
import { appConfig } from '../../config/app-config'
import { getBearerToken } from '../../auth/auth.utils'
import { errorResponseInterceptor } from '../interceptors/responseInterceptor'

export const ExpertsClient = axios.create({
    baseURL: appConfig.expertsApiBaseUrl,
    headers: {
        'X-Caller-Service': 'experts-client',
    },
})

ExpertsClient.interceptors.request.use(config => {
    const token = getBearerToken()
    if (token) {
        config.headers.Authorization = token
    }
    return config
})

ExpertsClient.interceptors.response.use(response => response, errorResponseInterceptor)
